import { render, staticRenderFns } from "./ExtraWorkManagementDetails.vue?vue&type=template&id=b59f2b42&scoped=true&"
import script from "./ExtraWorkManagementDetails.vue?vue&type=script&lang=js&"
export * from "./ExtraWorkManagementDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExtraWorkManagementDetails.vue?vue&type=style&index=0&id=b59f2b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59f2b42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VCol,VDialog,VRow,VSpacer})
